import * as membershipApi from "../services/membership-api"
import * as permissionsApi from "../../permissions/services/permissions-api"
import * as actions from "../store/actions"
import * as permissionActions from "../../permissions/store/actions"
import { useSafeDispatch } from "../../hooks/use-safe-dispatch"
import { IMembershipResponse } from "../interfaces/membership-response"
import { MembershipPermissionResponse } from "../../permissions/interfaces/membership-permission"

export const useMembershipActions = () => {
  const dispatch = useSafeDispatch()

  const addMembership = (orgId: string, newMembership: membershipApi.NewMemberData) => {
    return dispatch<IMembershipResponse>(actions.AddMembership({ orgId, ...newMembership }))
  }

  const updateInfo = (membershipId: string, updateData: membershipApi.MembershipInfoUpdateData) => {
    return dispatch<IMembershipResponse>(actions.UpdateMembershipInfo({ membershipId, ...updateData }))
  }

  const updateAssociations = (membershipId: string, updateData: permissionsApi.MemberAssociationsUpdateData) => {
    return dispatch<MembershipPermissionResponse>(
      permissionActions.UpdateMemberAssociations({ membershipId, ...updateData })
    )
  }

  const updateAbilitiesInResources = (
    membershipId: string,
    updateData: permissionsApi.MemberAbilitiesInResourcesUpdateData
  ) => {
    return dispatch<MembershipPermissionResponse>(
      permissionActions.UpdateMemberAbilitiesInResources({ membershipId, ...updateData })
    )
  }

  const sendInvitation = (data: membershipApi.SendInvitationActionData) => {
    return dispatch<IMembershipResponse>(actions.SendInvitation(data))
  }

  const cancelInvitation = (membershipId: string) => {
    return dispatch<IMembershipResponse>(actions.CancelInvitation(membershipId))
  }

  const copyPermissions = (membershipId: string, copyPermissionsFrom: string) => {
    return dispatch<MembershipPermissionResponse>(
      permissionActions.CopyMembershipPermissions({ membershipId, copyPermissionsFrom })
    )
  }

  const updateAbilties = (abiltiesUpdateData: permissionsApi.MembershipAbilitiesUpdateData) => {
    return dispatch<MembershipPermissionResponse>(permissionActions.UpdateMembershipAbilities(abiltiesUpdateData))
  }

  return {
    addMembership,
    updateInfo,
    updateAbilitiesInResources,
    updateAssociations,
    sendInvitation,
    cancelInvitation,
    copyPermissions,
    updateAbilties,
  }
}
